
import axios from 'axios';

const API_BASE_URL = 'https://api.jamboricg.com/api/contributions';

export const GeneralContributionService = {
    // ========== FUND CATEGORIES ==========
    getAllCategories: async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/categories/`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    createCategory: async (categoryData) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/categories/`, categoryData, {
                headers: {
                    'Authorization': `Token ${localStorage.getItem('token')}`
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    updateCategory: async (id, categoryData) => {
        try {
            const response = await axios.put(`${API_BASE_URL}/categories/${id}/`, categoryData, {
                headers: {
                    'Authorization': `Token ${localStorage.getItem('token')}`
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    deleteCategory: async (id) => {
        try {
            const response = await axios.delete(`${API_BASE_URL}/categories/${id}/`, {
                headers: {
                    'Authorization': `Token ${localStorage.getItem('token')}`
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // ========== FUNDS ==========
    getAllFunds: async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/funds/`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    getFundById: async (id) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/funds/${id}/`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    createFund: async (fundData) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/funds/`, fundData, {
                headers: {
                    'Authorization': `Token ${localStorage.getItem('token')}`
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    updateFund: async (id, fundData) => {
        try {
            const response = await axios.put(`${API_BASE_URL}/funds/${id}/`, fundData, {
                headers: {
                    'Authorization': `Token ${localStorage.getItem('token')}`
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    deleteFund: async (id) => {
        try {
            const response = await axios.delete(`${API_BASE_URL}/funds/${id}/`, {
                headers: {
                    'Authorization': `Token ${localStorage.getItem('token')}`
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    getFundAccounts: async (fundId) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/funds/${fundId}/accounts/`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    getFundStatistics: async (fundId) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/funds/${fundId}/statistics/`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    getFundsByCategory: async (categoryType) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/funds/by_category/?category_type=${categoryType}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // ========== FUND ACCOUNTS ==========
    getAllAccounts: async (fundId = null) => {
        try {
            const url = fundId 
                ? `${API_BASE_URL}/accounts/?fund=${fundId}`
                : `${API_BASE_URL}/accounts/`;
            const response = await axios.get(url);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    createAccount: async (accountData) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/accounts/`, accountData, {
                headers: {
                    'Authorization': `Token ${localStorage.getItem('token')}`
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    updateAccount: async (id, accountData) => {
        try {
            const response = await axios.put(`${API_BASE_URL}/accounts/${id}/`, accountData, {
                headers: {
                    'Authorization': `Token ${localStorage.getItem('token')}`
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    deleteAccount: async (id) => {
        try {
            const response = await axios.delete(`${API_BASE_URL}/accounts/${id}/`, {
                headers: {
                    'Authorization': `Token ${localStorage.getItem('token')}`
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // ========== CONTRIBUTIONS ==========
    getAllContributions: async (filters = {}) => {
        try {
            const params = new URLSearchParams();
            if (filters.fund) params.append('fund', filters.fund);
            if (filters.status) params.append('status', filters.status);
            if (filters.payment_method) params.append('payment_method', filters.payment_method);

            const response = await axios.get(`${API_BASE_URL}/contributions/?${params.toString()}`, {
                headers: {
                    'Authorization': `Token ${localStorage.getItem('token')}`
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    createContribution: async (contributionData) => {
        try {
            const formData = new FormData();
            Object.keys(contributionData).forEach(key => {
                if (contributionData[key] !== null && contributionData[key] !== undefined) {
                    formData.append(key, contributionData[key]);
                }
            });

            const response = await axios.post(`${API_BASE_URL}/contributions/`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Token ${localStorage.getItem('token')}`
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    getMyContributions: async (filters = {}) => {
        try {
            const params = new URLSearchParams();
            if (filters.fund) params.append('fund', filters.fund);
            if (filters.status) params.append('status', filters.status);

            const response = await axios.get(
                `${API_BASE_URL}/contributions/my_contributions/?${params.toString()}`,
                {
                    headers: {
                        'Authorization': `Token ${localStorage.getItem('token')}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    getMySummary: async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/contributions/my_summary/`, {
                headers: {
                    'Authorization': `Token ${localStorage.getItem('token')}`
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    approveContribution: async (id) => {
        try {
            const response = await axios.post(
                `${API_BASE_URL}/contributions/${id}/approve/`,
                {},
                {
                    headers: {
                        'Authorization': `Token ${localStorage.getItem('token')}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    rejectContribution: async (id, reason) => {
        try {
            const response = await axios.post(
                `${API_BASE_URL}/contributions/${id}/reject/`,
                { reason },
                {
                    headers: {
                        'Authorization': `Token ${localStorage.getItem('token')}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    bulkApproveContributions: async (contributionIds) => {
        try {
            const response = await axios.post(
                `${API_BASE_URL}/contributions/bulk_approve/`,
                { contribution_ids: contributionIds },
                {
                    headers: {
                        'Authorization': `Token ${localStorage.getItem('token')}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // ========== CONTRIBUTION SUMMARIES ==========
    getAllSummaries: async (fundId = null) => {
        try {
            const url = fundId 
                ? `${API_BASE_URL}/summaries/?fund=${fundId}`
                : `${API_BASE_URL}/summaries/`;
            const response = await axios.get(url, {
                headers: {
                    'Authorization': `Token ${localStorage.getItem('token')}`
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    getLeaderboard: async (fundId) => {
        try {
            const response = await axios.get(
                `${API_BASE_URL}/summaries/leaderboard/?fund=${fundId}`,
                {
                    headers: {
                        'Authorization': `Token ${localStorage.getItem('token')}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },
};

export default GeneralContributionService;

